import React, { useRef } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { useHover } from 'react-native-web-hooks';

const ServiceRowTouchable = ({
  onPress, chosenServices,
}) => {
  const myStyles = {
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: 210,
    },
    TextStyle: { fontSize: 13 },
  };
  const rowRef = useRef(null);
  const isHoveredRow = useHover(rowRef);
  return (
    <View ref={rowRef} style={myStyles.container}>
      <TouchableOpacity
        onPress={() => {
          onPress(chosenServices);
        }}
      >
        <View style={{
          backgroundColor: isHoveredRow ? '#edf2f7' : '#ffffff', width: 208, paddingStart: 20, paddingVertical: 5,
        }}
        >
          <Text
            style={myStyles.TextStyle}
          >
            {chosenServices}
          </Text>
        </View>

      </TouchableOpacity>
    </View>
  );
};
export default ServiceRowTouchable;
